export default __webpack_public_path__ + "static/media/iwmi-pdf-header.1719ab66.png";